import { createRouter, createWebHistory } from 'vue-router';
import Error from '@/views/Error.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', redirect: '/operations' },
    {
      path: '/settings',
      name: 'settings-view',
      component: () => import('@/views/SettingsView.vue'),
      redirect: '/settings/metadata',
      children: [
        {
          path: 'metadata',
          component: () => import('@/components/settings/metadata/MetadataTab.vue'),
          redirect: '/settings/metadata/sports',
          children: [
            {
              path: 'sports/:id?',
              component: () => import('@/components/settings/metadata/sports/SportsEntity.vue'),
            },
            {
              path: 'categories/:id?',
              component: () =>
                import('@/components/settings/metadata/categories/CategoriesEntity.vue'),
            },
            {
              path: 'tournaments/:id?',
              component: () =>
                import('@/components/settings/metadata/tournaments/TournamentsEntity.vue'),
            },
            {
              path: 'tournament-rounds/:id?',
              component: () =>
                import('@/components/settings/metadata/tournament-rounds/TournamentRounds.vue'),
            },
            {
              path: 'markets/:id?',
              component: () => import('@/components/settings/metadata/markets/MarketsEntity.vue'),
            },
            {
              path: 'market-groups/:id?',
              component: () =>
                import('@/components/settings/metadata/market-groups/MarketGroupsEntity.vue'),
            },
            {
              path: 'outcomes/:id?',
              component: () => import('@/components/settings/metadata/outcomes/OutcomesEntity.vue'),
            },
            {
              path: 'teams/:id?',
              component: () => import('@/components/settings/metadata/teams/TeamsEntity.vue'),
            },
            {
              path: 'players/:id?',
              component: () => import('@/components/settings/metadata/players/PlayersEntity.vue'),
            },
          ],
        },
        {
          path: 'offer-template/:id?',
          component: () => import('@/components/settings/offer-template/OfferTemplate.vue'),
        },
        {
          name: 'selections-automatization',
          path: 'selections-automatization/:id?/:timelineType?/:timelineId?',
          component: () =>
            import('@/components/settings/selections-automatization/SelectionsAutomatization.vue'),
        },
        {
          path: 'results/:id?',
          component: () => import('@/components/settings/results/ResultsEntity.vue'),
        },
        {
          path: 'limits/',
          component: () => import('@/components/settings/limits/LimitsTab.vue'),
          redirect: '/settings/limits/global',
          children: [
            {
              path: 'global/:id?',
              component: () => import('@/components/settings/limits/global/GlobalEntity.vue'),
            },
            {
              path: 'limit-groups/:id?',
              component: () => import('@/components/settings/limits/groups/LimitGroups.vue'),
            },
            {
              path: 'limit-group-collections/:id?',
              component: () =>
                import('@/components/settings/limits/group-collection/LimitGroupCollection.vue'),
            },
            {
              path: 'bet-targets/:id?',
              component: () => import('@/components/settings/limits/bet-target/BetTarget.vue'),
            },
          ],
        },
        {
          path: 'resolve-formula/',
          component: () =>
            import('@/components/settings/resolve-formula/ResolveFormulaMainTab.vue'),
          redirect: '/settings/resolve-formula/resolve-formula',
          children: [
            {
              path: 'resolve-formula/:id?',
              component: () =>
                import('@/components/settings/resolve-formula/resolve-formula/ResolveFormula.vue'),
            },
            {
              path: 'resolve-formula-tier/:id?',
              component: () =>
                import('@/components/settings/resolve-formula/resolve-formula-tier/ResolveFormulaTier.vue'),
            },
            {
              path: 'resolve-formula-set/:id?',
              component: () =>
                import('@/components/settings/resolve-formula/resolve-formula-set/ResolveFormulaSet.vue'),
            },
            {
              path: 'market-outcome-resolve-formula-set/:id?',
              component: () =>
                import('@/components/settings/resolve-formula/market-outcome-resolve-formula-set/MarketOutcomeResolveFormulaSet.vue'),
            },
            {
              path: 'outcome-assignment/:id?',
              component: () =>
                import('@/components/settings/resolve-formula/outcome-assignment/OutcomeAssignment.vue'),
            },
          ],
        },
        {
          path: 'display-templates/',
          component: () =>
            import('@/components/settings/display-templates/DisplayTemplatesTab.vue'),
        },
        {
          path: 'tags/:id?',
          component: () => import('@/components/settings/tags/TagsList.vue'),
        },
        {
          path: 'streams/:id?',
          component: () => import('@/components/settings/stream/StreamList.vue'),
        },
        {
          path: 'liability-templates/',
          component: () =>
            import('@/components/settings/liability-templates/LiabilityTemplates.vue'),
          name: 'liabilityTemplates',
        },
        {
          path: 'liability/',
          name: 'liability',
          redirect: '/settings/liability/risk-configuration',
          component: () => import('@/components/settings/liability/LiabilityTab.vue'),
          children: [
            {
              path: 'risk-configuration',
              component: () =>
                import('@/components/settings/liability/risk-configuration/RiskConfiguration.vue'),
            },
            {
              path: 'sports',
              component: () => import('@/components/settings/liability/entities/Sports.vue'),
            },
            {
              path: 'categories',
              component: () => import('@/components/settings/liability/entities/Categories.vue'),
            },
            {
              path: 'tournaments',
              component: () => import('@/components/settings/liability/entities/Tournaments.vue'),
            },
            {
              path: 'tournament-rounds',
              component: () =>
                import('@/components/settings/liability/entities/TournamentRounds.vue'),
            },
            {
              path: 'markets',
              component: () => import('@/components/settings/liability/entities/Markets.vue'),
            },
            {
              path: 'punters',
              component: () => import('@/components/settings/liability/entities/Punters.vue'),
            },
            {
              path: 'custom-bet',
              component: () => import('@/components/settings/liability/entities/CustomBet.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/operations',
      name: 'operations-view',
      component: () => import('@/views/OperationsView.vue'),
      redirect: '/operations/events',
      alias: '/',
      children: [
        {
          path: 'events',
          component: () => import('@/components/operations/events/EventsTab.vue'),
          redirect: '/operations/events/prematch',
          children: [
            {
              path: 'all/:id?',
              component: () => import('@/components/operations/events/all/AllEvents.vue'),
            },
            {
              path: 'prematch/:id?',
              component: () => import('@/components/operations/events/prematch/PrematchEvents.vue'),
            },
            {
              path: 'live/:id?',
              component: () => import('@/components/operations/events/live/LiveEvents.vue'),
            },
          ],
        },
        {
          path: 'bets/:id?',
          component: () => import('@/components/operations/bets/BetList.vue'),
        },
        {
          path: 'offer-template-events',
          component: () =>
            import('@/components/operations/offer-template-events/OfferTemplateEvents.vue'),
          redirect: '/operations/offer-template-events/all',
          children: [
            {
              path: 'all/:id?',
              component: () =>
                import('@/components/operations/offer-template-events/all/AllEvents.vue'),
            },
            {
              path: 'prematch/:id?',
              component: () =>
                import('@/components/operations/offer-template-events/prematch/PrematchEvents.vue'),
            },
            {
              path: 'live/:id?',
              component: () =>
                import('@/components/operations/offer-template-events/live/LiveEvents.vue'),
            },
          ],
        },
        {
          path: 'ticket-authorization',
          component: () =>
            import('@/components/operations/ticket-authorization/TicketAuthorization.vue'),
        },
        {
          path: 'event-results/:id?',
          component: () => import('@/components/operations/event-results/EventResults.vue'),
        },
        {
          path: 'liability-monitoring/:id?',
          component: () =>
            import('@/components/operations/liability-monitoring/LiabilityMonitoring.vue'),
        },
        {
          path: 'promoted-offer',
          component: () => import('@/components/operations/promoted-offer/PromotedOffer.vue'),
          redirect: '/operations/promoted-offer/offer',
          children: [
            {
              path: 'offer/:id?',
              component: () => import('@/components/operations/promoted-offer/offer/OfferTab.vue'),
            },
            {
              path: 'catalogue/:id?',
              component: () =>
                import('@/components/operations/promoted-offer/catalogue/CatalogueTab.vue'),
            },
            {
              path: 'promoted-offer-layout/:id?',
              component: () =>
                import('@/components/operations/promoted-offer-layout/PromotedOfferLayout.vue'),
            },
          ],
        },
        {
          path: 'promoted-offer-layout/:id?',
          component: () =>
            import('@/components/operations/promoted-offer-layout/PromotedOfferLayout.vue'),
        },
        {
          path: 'recommended-betslips',
          component: () =>
            import('@/components/operations/recommended-betslips/RecommendedBetslip.vue'),
          redirect: '/operations/recommended-betslips/recommended-betslip',
          children: [
            {
              path: 'recommended-betslip/:id?',
              component: () =>
                import('@/components/operations/recommended-betslips/recommended-betslip/RecommendedBetslipTab.vue'),
            },
            {
              path: 'recommended-betslip-group/:id?',
              component: () =>
                import('@/components/operations/recommended-betslips/recommended-betslip-group/RecommendedBetslipGroup.vue'),
            },
          ],
        },
        {
          path: 'feed-mapping',
          component: () => import('@/components/operations/feed-mapping/FeedMapping.vue'),
          redirect: '/operations/feed-mapping/events',
          children: [
            {
              path: 'events/:id?',
              component: () =>
                import('@/components/operations/feed-mapping/events/EventsTable.vue'),
            },
          ],
        },
        {
          path: 'feed-mapping-alert-configuration',
          name: 'feed-mapping-alert-configuration',
          component: () =>
            import(
              '@/components/operations/feed-mapping-alert-configuration/FeedMappingAlertConfiguration.vue'
            ),
        },
        {
          path: 'feed-recovery',
          name: 'feed-recovery',
          component: () => import('@/components/operations/feed-recovery/FeedRecovery.vue'),
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      component: Error,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const tenantUuid = from.query.tenantUuid;

  if (tenantUuid && !to.query.tenantUuid)
    next({
      ...to,
      query: {
        ...to.query,
        tenantUuid,
      },
    });
  else next();
});

export default router;
